export default (query, pageLimit, offset, totalResults) => {
  const nextOffset = pageLimit ? offset + pageLimit : undefined;
  const nextPageQuery =
    nextOffset && nextOffset < totalResults
      ? { ...query, offset: nextOffset || offset }
      : undefined;

  return nextPageQuery;
};
